export default "__VITE_ASSET__bac91060__"